import * as React from "react"

function SvgChat(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.255 14.256"
      {...props}
    >
      <path
        d="M7.132 0A7.128 7.128 0 00.949 10.676l-.918 2.852a.557.557 0 00.7.7l2.852-.918A7.128 7.128 0 107.131-.001zm0 13.142a6 6 0 01-3.183-.911.561.561 0 00-.466-.059l-2.059.664.663-2.059a.559.559 0 00-.058-.467 6.014 6.014 0 115.1 2.831zm.7-6.015a.7.7 0 11-.7-.7.7.7 0 01.692.7zm2.785 0a.7.7 0 11-.7-.7.7.7 0 01.691.7zm-5.569 0a.7.7 0 11-.7-.7.7.7 0 01.692.7z"
        fill="inherit"
      />
    </svg>
  )
}

export default SvgChat
